import Vue from 'vue';
import VueCookies from 'vue-cookies';
import VueTheMask from 'vue-the-mask'; // Profile
import VueI18n from 'vue-i18n';
import {MediaQueries} from 'vue-media-queries';
import PortalVue from 'portal-vue';
import Intersect from 'vue-intersect';
import axios from 'axios';

import ACooldown from '../components/util/ACooldown';
import ATunnel from "../components/util/ATunnel.vue";
import AutoComplete from '../components/util/AutoComplete.vue';
import AjaxForm from '../components/util/AjaxForm';
import CountDown from '../components/util/CountDown';
import Collapsible from '../components/util/Collapsible';
import CollapsibleGroup from '../components/util/CollapsibleGroup';
import FadeList from "../components/util/FadeList.vue";
import HoldButton from '../components/util/HoldButton.vue';
import NewsletterForm from '../components/util/NewsletterForm';
import Notification from '../components/util/Notification';
import Popup from '../components/util/Popup';
import ReadMore from '../components/util/ReadMore';
import ReadEvenMore from '../components/util/ReadEvenMore';
import SmartForm from '../components/util/SmartForm';
import SmartToggle from '../components/util/SmartToggle';
import Swiper from '../components/util/Swiper';
import Tab from '../components/util/Tab';
import Tabs from '../components/util/Tabs';
import Ticker from '../components/util/Ticker';
import TitleFlipper from '../components/util/TitleFlipper';
import FaviconFlipper from '../components/util/FaviconFlipper';

import APopunder from "../components/popunder/APopunder.vue";
import PopunderZone from "../components/popunder/PopunderZone.vue";

import AutoLogin from '../components/auth/AutoLogin';
import SignInForm from '../components/auth/SignInForm';
import SignUpForm from '../components/auth/SignUpForm';
import UpgradeMembershipForm from '../components/auth/UpgradeMembershipForm';
import DirectUpgradeForm from '../components/auth/DirectUpgradeForm';

import TrackingZone from "../components/tracking/TrackingZone";
import PartnerUpsell from "../components/sidebar/PartnerUpsell.vue";
import ChannelUpsell from "../components/sidebar/ChannelUpsell.vue";
import NetworkUpsell from "../components/sidebar/NetworkUpsell.vue";

import RecoverPasswordForm from '../components/password/RecoverPasswordForm';
import ResetPasswordForm from '../components/password/ResetPasswordForm';

import notificationsStore from "../components/notifications/notifications-store";
import NotificationsList from '../components/notifications/NotificationsList';

import DynamicSidebar from "../components/sidebar/DynamicSidebar.vue";
import ASidebar from "../components/sidebar/ASidebar.vue";
import AChannelSidebar from "../components/sidebar/AChannelSidebar.vue";
import ANetworkSidebar from "../components/sidebar/ANetworkSidebar.vue";
import APartnerSidebar from "../components/sidebar/APartnerSidebar.vue";
import SignUpFormLoader from '../components/sidebar/SignUpFormLoader';

import SubscribeButton from "../components/subscription/SubscribeButton.vue";

import VideoPreview from '../components/video/VideoPreview';

import BasicFrame from "../components/video/BasicFrame";
import SvgObserver from "../components/global/SvgObserver";
import ForceUpgradeModal from "../components/global/ForceUpgradeModal.vue";

import directives from '../directives';
import LazyLoad from 'vanilla-lazyload';
import XvidApi from "../helpers/xvid-api";

import CamBannerArea from "../cams/CamBannerArea";
import CamPopup from "../cams/CamPopup";
import {resolveCamsApi} from "../cams";

import * as Hotjar from "../thirdparty/hotjar";
import ScrollRetain from "../components/util/ScrollRetain";

Vue.use(VueCookies);
Vue.use(VueTheMask);
Vue.use(VueI18n);
const mqInstance = new MediaQueries();
Vue.use(mqInstance);
Vue.use(PortalVue);

Vue.component('Intersect', Intersect);

Vue.component('ACooldown', ACooldown);
Vue.component('ATunnel', ATunnel);
Vue.component('AutoComplete', AutoComplete);
Vue.component('AjaxForm', AjaxForm);
Vue.component('CountDown', CountDown);
Vue.component('Collapsible', Collapsible);
Vue.component('CollapsibleGroup', CollapsibleGroup);
Vue.component('FadeList', FadeList);
Vue.component('HoldButton', HoldButton);
Vue.component('Notification', Notification);
Vue.component('NewsletterForm', NewsletterForm);
Vue.component('Popup', Popup);
Vue.component('ReadMore', ReadMore);
Vue.component('ReadEvenMore', ReadEvenMore);
Vue.component('SmartForm', SmartForm);
Vue.component('SmartToggle', SmartToggle);
Vue.component('Swiper', Swiper);
Vue.component('Tab', Tab);
Vue.component('Tabs', Tabs);
Vue.component('Ticker', Ticker);
Vue.component('TitleFlipper', TitleFlipper);
Vue.component('FaviconFlipper', FaviconFlipper);
Vue.component('ScrollRetain', ScrollRetain);

Vue.component('APopunder', APopunder);
Vue.component('PopunderZone', PopunderZone);

Vue.component('AutoLogin', AutoLogin);
Vue.component('SignInForm', SignInForm);
Vue.component('SignUpForm', SignUpForm);
Vue.component('UpgradeMembershipForm', UpgradeMembershipForm);
Vue.component('DirectUpgradeForm', DirectUpgradeForm);

Vue.component('TrackingZone', TrackingZone);
Vue.component('PartnerUpsell', PartnerUpsell);
Vue.component('ChannelUpsell', ChannelUpsell);
Vue.component('NetworkUpsell', NetworkUpsell);

Vue.component('RecoverPasswordForm', RecoverPasswordForm);
Vue.component('ResetPasswordForm', ResetPasswordForm);

Vue.component('NotificationsList', NotificationsList);

Vue.component('DynamicSidebar', DynamicSidebar);
Vue.component('ASidebar', ASidebar);
Vue.component('AChannelSidebar', AChannelSidebar);
Vue.component('ANetworkSidebar', ANetworkSidebar);
Vue.component('APartnerSidebar', APartnerSidebar);
Vue.component('SignUpFormLoader', SignUpFormLoader);

Vue.component('VideoGallery', () => import(/* webpackChunkName: 'video-gallery' */ '../components/video/VideoGallery'));

Vue.component('VideoComments', () => import(/* webpackChunkName: 'video-page' */ '../components/video/VideoComments'));
Vue.component('VideoFavorite', () => import(/* webpackChunkName: 'video-page' */ '../components/video/VideoFavorite'));
Vue.component('VideoWatchLater', () => import(/* webpackChunkName: 'video-page' */ '../components/video/VideoWatchLater'));
Vue.component('VideoLikes', () => import(/* webpackChunkName: 'video-page' */ '../components/video/VideoLikes'));
Vue.component('VideoPreview', VideoPreview);
Vue.component('PosterVideo', () => import(/* webpackChunkName: 'video-page' */ '../components/video/PosterVideo'));
Vue.component('XvidPopup', () => import(/* webpackChunkName: 'video-page' */ '../components/video/XvidPopup'));

Vue.component('VideoPlayerIntegrated', () => import(/* webpackChunkName: 'video-page' */ '../components/video/player/VideoPlayerIntegrated'));
Vue.component('VideoPlayerUnlockable', () => import(/* webpackChunkName: 'video-page' */ '../components/video/player/VideoPlayerUnlockable'));

Vue.component('PlaylistAddForm', () => import(/* webpackChunkName: 'video-page' */ '../components/playlist/PlaylistAddForm'));
Vue.component('EditablePlaylist', () => import(/* webpackChunkName: 'profile-page' */ '../components/playlist/EditablePlaylist'));
Vue.component('PlaylistRenameForm', () => import(/* webpackChunkName: 'profile-page' */ '../components/playlist/PlaylistRenameForm'));
Vue.component('PlaylistDeleteButton', () => import(/* webpackChunkName: 'profile-page' */ '../components/playlist/PlaylistDeleteButton'));

Vue.component('SubscriptionList', () => import(/* webpackChunkName: 'profile-page' */ '../components/subscription/SubscriptionList'));
Vue.component('SubscribeButton', SubscribeButton);

Vue.component('BasicFrame',  BasicFrame);

Vue.component('CamBannerArea', CamBannerArea);
Vue.component('CamPopup', CamPopup);



Vue.component('FooterAwards',  () => import(/* webpackChunkName: 'footer-lazy' */ '../components/footer/FooterAwards'));
Vue.component('FooterLegal', () => import(/* webpackChunkName: 'footer-lazy' */ '../components/footer/FooterLegal'));

Vue.component('CookiesModule', () => import(/* webpackChunkName: 'cookies-lazy' */ '../components/util/CookiesModule'));

Vue.component('svgObserver',  SvgObserver);
Vue.component('ForceUpgradeModal',  ForceUpgradeModal);

Object.entries(directives).forEach(([key, value]) => Vue.directive(key, value));

const camsApi = resolveCamsApi(window.variables.cams || {});

window.app = new Vue({
    el: '#vue-app',
    data: {
        showCookiesModule: null,
        activePopup: null,
        results: {
            header: {},
            content: {
                actors: {
                    items: [],
                },
                categories: {
                    items: [],
                },
                partners: {
                    items: [],
                },
            },
        },
        videos: {
            download: null,
        },
        variables: window.variables,
        isRelatedToggled: false,
        isLanguageItemVisible: false,
        xvidApi: new XvidApi(window.variables.xvidDomain),

        footerYellowBar: true, // It's opened by default
        superbePop: true, // It's opened by default
        brazilIndia: true, // It's opened by default
        hideSoftPopUp: $cookies.isKey('_sVpo'),
        visibleSoftPopUp: false,
        modals: {},
        service: {},
        intersectedWith: {
            footer: {
                address: false,
                awards: false,
                legal: false,
            }
        },
        clientScrollRatio: 0,
        camsApi,
        popUnders: window.variables.popUnder,
        notifications: notificationsStore,
        lazyLoad: null,
    },
    methods: {
        showPopup(popupRef, params = {}) {
            if (!this.$refs.hasOwnProperty(popupRef)) {
                console.warn('Invalid popup ref: ' + popupRef);
                return;
            }

            if (this.activePopup) {
                this.$refs[this.activePopup].hide();
            }

            this.$refs[popupRef].setParams(params);
            this.$refs[popupRef].show();
            this.activePopup = popupRef;
        },

        hide_offer_partner() {
            axios({ url: '/service/dismiss/_pOdP_.json'}).then(response => {
                this.footerYellowBar = false;
            });
        },
        toggle_soft_pop() {
            if ( $cookies.isKey('_sVpo')) {
                $cookies.remove('_sVpo');
                this.hideSoftPopUp = false;
            } else {
                $cookies.set('_sVpo', 1);
                this.hideSoftPopUp = true;
            }
        },
        hide_offer_upgrade() {
            $cookies.set('_pUo', 1);
        },
        hide_offer_network() {
            $cookies.set('_pOn', 1);
        },
        hide_superbe_pop() {
            axios({ url: '/service/dismiss/_sPoU.json'}).then(response => {
                this.superbePop = false;
            });
        },
        hide_brazil_india_pop() {
            axios({ url: '/service/dismiss/_bIpU.json'}).then(response => {
                this.brazilIndia = false;
            });
        },
        signUpSubmit() {
            this.$refs.signUpForm && this.$refs.signUpForm.jsonpSubmit();
        },
        async checkXvidAccess(urls) {
            if (!this.$refs.xvidPopup) {
                return true;
            }

            return await this.$refs.xvidPopup.checkAccess(urls);
        },

        ensurePremium() {
            if (this.variables.auth.premium) {
                return true;
            }

            this.showUpgradePrompt();
            return false;
        },

        showUpgradePrompt() {
            if (this.$refs.hasOwnProperty('sidebarUpgradeMembership')) {
                this.sidebar('upgrade-membership');
            } else if (this.$refs.hasOwnProperty('upgradeModal')) {
                this.showPopup('upgradeModal');
            } else {
                this.sidebar('signup-form');
            }
        },

        setPath(object, path, value) {
            path.split('.').reduce((o,p,i) => o[p] = path.split('.').length === ++i ? value : o[p] || {}, object);
        },

        ping(url) {
            axios.get(url);
        },

        scrollToTop() {
            window.scrollTo({top: 0, behavior: 'smooth'});
        },
        sidebar(target) {
            this.$refs.sidebar.show(target);
        },
        scrollRetainDelete() {
            localStorage.removeItem("scrollPosition");
        },
    },

    provide: {
        reCaptchaKey: window.variables.reCaptchaPublicKey,
        newsletterSubscribeUrl: window.variables.newsletterSubscribeUrl,
        skipCaptcha: window.variables.skipCaptcha || false,
        camsApi,
        trackingUrls: window.variables.trackingUrls || {},
        triggerCooldownUrl: window.variables.triggerCooldownUrl,
        playlistUrls: window.variables.playlistUrls || {},
    },

    i18n: new VueI18n({
        locale: 'en',
        messages: {},
        ...window.vueI18n,
    }),

    mediaQueries: mqInstance,

    async mounted() {
        this.lazyLoad = new LazyLoad({
            elements_selector: '.lazy',
        });

        let loadAnalytics = false;
        if($cookies.isKey('_cMo')) {
            const acceptedCookies = $cookies.get('_cMo').split(',');

            if(acceptedCookies.includes('analytical')) {
                loadAnalytics = true;
            }
        }

        if(loadAnalytics && this.variables.hotjarId) {
            await Hotjar.load(this.variables.hotjarId);
        }

        let clickHandler = ('ontouchstart' in document.documentElement ? "touchstart" : "click");

        document.addEventListener('readystatechange', function (event) {
            if (event.target.readyState === 'complete') {
                let time = ((new Date().getTime()) - variables.timestamp) / 1000; //in ms
                console.log(time + " seconds");
            }
        }, { passive: true });

        let scrollPosition = 0;

        window.addEventListener('scroll', () => {
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (scrollTop > scrollPosition){
                document.querySelector('body').classList.add("hide-marketplace-bar");
                console.log('scroll2');
                this.visibleSoftPopUp = true;
            } else {
                document.querySelector('body').classList.remove("hide-marketplace-bar");
            }
            scrollPosition = scrollTop <= 0 ? 0 : scrollTop;
        }, { passive: true });

        // Focus on sign-up email
        //let iSu, suThumbEl = document.getElementsByClassName('-su-thumb-media');
        let iSu, suThumbEl = document.querySelectorAll('[data-signup-thumb-action]');
        let registerInput = document.getElementById('input-register-email');
        if (registerInput !== null) {
            initSignUpEmailInput();

            for (iSu = 0; iSu < suThumbEl.length; iSu++) {
                suThumbEl[iSu].addEventListener('click', initSignUpEmailInput);
            }
        }

        function initSignUpEmailInput() {
            window.scrollTo(0, 0);
            registerInput.focus();
        }

        // Fade out some elements
        document.body.addEventListener(clickHandler, function (event) {
            if (event.target.dataset.hasOwnProperty('animationTarget') === true ) {
                let el = document.getElementById(event.target.dataset.animationTarget);
                el.style.opacity = 1;
                (function fade(){
                    (el.style.opacity-=0.1)<0?el.style.display="none":setTimeout(fade,25)
                })();
            }
        }, { passive: true });

        // Replicate clicks on Swiper duplicate slides
        let duplicateSwiperSlide = document.getElementsByClassName('swiper-slide-duplicate');

        let findOriginalSlide = function(e) {
            const slideIndex = this.getAttribute('data-swiper-slide-index');
            let groupedByIndex = this.closest('.swiper-wrapper').querySelectorAll('[data-swiper-slide-index="' + slideIndex + '"]');

            // only one slide from "groupedByIndex" does't have class 'swiper-slide-duplicate'
            for (let i = 0; i < groupedByIndex.length; i++) {
                if (groupedByIndex[i].classList.contains('swiper-slide-duplicate')) {
                    // do nothing
                } else {
                    let theAction = groupedByIndex[i].getElementsByTagName('a')[0];
                    theAction.click();
                }
            }

            e.preventDefault();
            e.stopPropagation();
        };

        for (let i = 0; i < duplicateSwiperSlide.length; i++) {
            duplicateSwiperSlide[i].addEventListener('click', findOriginalSlide, false);
        }

        // Determine the scroll top value and ratio
        // This is used to show/hide footer address frame
        let body = document.body;
        let html = document.documentElement;
        let time = 0;
        let calc = () => {
            clearTimeout(time);
            time = setTimeout(() => {
                let pageHeight = Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight );
                let clientScroll = (( window.pageYOffset || html.scrollTop ) - (html.clientTop || 0 ));
                this.$nextTick(() => {
                    this.clientScrollRatio = clientScroll+html.clientHeight/pageHeight*100;
                });
            }, 50 );
        };
        window.addEventListener('scroll', calc, { capture: true, passive: true });
        calc();

        // Horizontal Text Scroll - Video Card
        let i, htsElement = document.getElementsByClassName('hts');
        for (i = 0; i < htsElement.length; i++) {
            htsElement[i].addEventListener('mouseover', htsOver, false);
            htsElement[i].addEventListener('mouseleave', htsOut, false);
        }

        function htsOver() {
            this.querySelector('.hts-insert').style.cssText += 'max-width: none';
            this.querySelector('.hts-insert-scroll').style.cssText += 'max-width: none';
            let scrollValue = this.querySelector('.hts-insert').offsetWidth - this.offsetWidth;
            let scrollSpeed = (scrollValue / 10) * 200;
            if (scrollValue > 1) {
                if (document.dir === 'rtl'){
                    this.querySelector('.hts-insert').style.cssText += `margin: 0 -${scrollValue}px 0 0`;
                } else {
                    this.querySelector('.hts-insert').style.cssText += `margin: 0 0 0 -${scrollValue}px`;
                }
                this.querySelector('.hts-insert').style.cssText += `transition: margin ${scrollSpeed}ms linear 0s;`;
            }
        }

        function htsOut() {
            this.querySelector('.hts-insert').style.cssText += 'transition: margin 0ms linear 0s; margin: 0; max-width: 100%';
            this.querySelector('.hts-insert-scroll').style.cssText += 'max-width: 100%';
        }

        // CARD WITH HOVER POPUP
        let c, cardPopupElement = document.getElementsByClassName('-gmc-popup');
        for (c = 0; c < cardPopupElement.length; c++) {
            cardPopupElement[c].addEventListener('mouseover', cardPopupOver, false);
            cardPopupElement[c].addEventListener('mouseleave', cardPopupOut, false);
        }

        function cardPopupOver() {
            if (this.parentElement.classList.contains('swiper-slide')) {
                this.parentElement.parentElement.parentElement.parentElement.parentElement.classList.add('-with-popup-active');
            }
        }

        function cardPopupOut() {
            if (this.parentElement.classList.contains('swiper-slide')) {
                this.parentElement.parentElement.parentElement.parentElement.parentElement.classList.remove('-with-popup-active');
            }
        }

        // Auto-Scroll Scenes
        let sceneIndex = document.getElementById('-scenes-index');
        if (sceneIndex !== null) {
            let thisUrl = document.URL;
            let thisAnchor = thisUrl.split('#');
            let header = document.getElementsByClassName('main-header');
            let headerHeight = header[0].offsetHeight;
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            if (thisAnchor.length > 1) {
                window.scroll({
                    top: scrollTop - headerHeight,
                    left: 0,
                    behavior: 'smooth',
                });
            }
        }
    }


});

if ( window.localStorage ) {
    localStorage.setItem('fluidQuality', '720p');
}
